enum ReportingType {
    StoreHistoric = "reporting/STORE_HISTORIC",
    StorePublic = "reporting/STORE_PUBLIC",
}

export default ReportingType;
